import { useEffect, useState } from "react";
import { getStats } from "../api/client";
import type { Stats } from "../api/types";

/** Live counters for the home page. Silent on failure: the page still reads. */
export function useStats(): { stats: Stats | null; loading: boolean } {
  const [stats, setStats] = useState<Stats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let live = true;
    getStats()
      .then((next) => {
        if (live) setStats(next);
      })
      .catch(() => {
        if (live) setStats(null);
      })
      .finally(() => {
        if (live) setLoading(false);
      });
    return () => {
      live = false;
    };
  }, []);

  return { stats, loading };
}
